﻿const en = {
  auth: {
    signingIn: 'Checking sign in status...',
    loading: 'Loading...',
    signInButton: 'Sign in',
    inactivityError: 'You were logged out due to inactivity. Please log in again',
  },
  notFoundPage:
    "Page is not available right now or doesn't exist. Please, try to go back and choose a different direction",
  notifications: {
    error: 'Oops...',
    success: 'Success!',
    requestIsProcessing: 'Your request is processing',
  },
  dashboard: {
    tabs: {
      projects: 'Projects',
      workflows: 'Workflows',
    },
    stats: {
      iterations: 'Iterations',
      errors: 'Errors',
      tasksCompleted: 'Tasks completed',
      onlineContributors: 'Online contributors',
    },
  },
  projectsPage: {
    createButtonLabel: 'New project',
    exportButtonLabel: 'Export',
    filtersButtonLabel: 'Filters',
    listHeaderTitle: 'Projects',
    listHeaderSubtitle: 'Manage your projects',
    boostPopover: 'End of the boost in',
    table: {
      name: 'Name',
      state: 'Status',
      segments: 'Segments',
      total: 'Total',
      inDirect: 'In direct', // not sure if this is the correct translation
      alerts: 'Alerts',
      actions: 'Actions',
    },
    dropdown: {
      open: 'Open',
      audience: 'Edit the audience',
      parameters: 'Edit the settings',
      boost1: 'Boost 1 hour',
      boost2: 'Boost 6 hours',
      boost3: 'Boost 12 hours',
      stopBoost: 'Stop the boost',
      duplicate: 'Duplicate',
      stop: 'Stop the project',
      archive: 'Archive',
    },
    modal: {
      create: {
        title: 'Add a project',
        subtitle: 'Create a project',
        label: 'Name',
        placeholder: 'Example: English',
        cancelButton: 'Back',
        submitButton: 'Next',
      },
      archive: {
        title: 'Archive the project',
        subtitle: 'Unfinished tasks will be cancelled.',
        cancelButton: 'Cancel',
        submitButton: 'Confirm',
      },
      stop: {
        title: 'Stop the project',
        subtitle: 'Are you sure you want to delete this post? This action cannot be undone.',
        cancelButton: 'Cancel',
        submitButton: 'Stop',
      },
    },
  },

  projectCreatePage: {
    titles: {
      1: 'Extraction types',
      2: 'Settings',
      3: 'Audience',
      4: 'Adding data',
    },

    descriptions: {
      1: 'Define the steps of your processing',
      2: 'Define the project settings',
      3: 'Choose the project audience',
      4: 'Upload the data to process',
    },
    tasksTitle: 'Tasks',

    collapse: {
      manualEntry: {
        title: 'Manual entry form',
        subtitle: 'Choose your form',
        button: 'Choose from the library',
      },
      generative: {
        title: 'Prefill my processing with a generative artificial intelligence',
        subtitle: 'Selected generative artificial intelligence',
      },
      artificialModel: {
        title: 'Prefill my processing with a configured artificial intelligence model',
      },
      SLA: {
        title: 'SLA',
        subtitle: 'If these commitments are exceeded, an alert is raised.',
      },
      processingTime: {
        title: 'Maximum completion time of the request',
        checkbox: {
          exerciseTime: {
            title: 'Exercise time and deadline',
            subtitle:
              'Jobs submitted before the deadline must be delivered within a fixed number of days.',
          },
          averageTime: {
            title: 'Completion time target',
            subtitle: ' ',
          },
        },
        form: {
          timeOfLifting: 'Time of lifting',
          dayOfDelivery: 'Day of delivery',
          cutOffTime: 'Cut off time',
          maxDeliveryTime: 'Maximum completion time',
        },
        button: {
          addHour: 'Add one hour of lifting time',
        },
      },
      objectiveQuality: {
        title: 'Quality objective',
      },
      productivityTargets: {
        title: 'Productivity targets',
        subtitle: 'Define your objectives for this project',
      },
      applicationsPurpose: {
        title: 'Purpose of the applications',
        form: {
          deliveryTime: 'Delivery time target',
          processingTime: 'Actual processing time of an application',
        },
      },
      contributorsObjective: {
        title: "Contributors' objective",
        form: {
          timeOfContribution: 'Effective time of a contribution',
          quality: 'Quality',
        },
      },
      alerts: {
        title: 'Alerts',
        subtitle: 'Set your alerts',
        form: {
          recepients: 'Recepients',
        },
        toggles: {
          sms: 'SMS alerts',
          email: 'Email alerts',
        },
        selectValues: {
          none: 'Uncheck',
          manager: 'All managers',
          admin: 'All administrators',
        },
      },
      parameters: {
        title: 'Parameters',
        subtitle: 'Choose an entry form',
      },
      diversification: {
        title: 'Diversification of respondents',
        form: {
          diversification: 'Diversification of respondents',
          minQualityLevel: 'Minimum quality level',
          numContributions: 'Number of contributions evaluated',
        },
      },
      managers: {
        title: 'Managers',
      },
      webhook: {
        title: 'Webhook',
        subtitle: 'Your notification URL',
        copyButton: 'Copy',
      },
      audience: {
        title: {
          contributors: 'Contributors',
          reviewers: 'Reviewers / Referees',
        },
        subtitle: {
          contributors: 'Define the contributors audience',
          reviewers: 'Define the reviewers audience',
        },
        external: {
          title: {
            contributors: 'External contributors',
            reviewers: 'External reviewers',
          },
          form: {
            title: {
              provider: 'Provider',
              segment: 'Segment',
              compensation: 'Compensation',
            },
            radio: {
              type: {
                amazon: 'Amazon mTurk',
                yappers: 'Yappers',
              },
              earnings: {
                0: 'Economic',
                1: 'Medium',
                2: 'Competitive',
                priceSubtitle: 'cents / job',
              },
            },
          },
        },
        internal: {
          title: {
            contributors: 'Internal contributors',
            reviewers: 'Internal reviewers',
          },
        },
      },
      generalSettings: {
        title: 'General settings',
      },
    },

    form: {
      label: {
        validationRate: 'Validation rate',
        prefillRate: 'Pre-fill rate',
        firstName: 'First name',
        lastName: 'Last name',
        client: 'Client',
      },
      placeholder: {
        firstName: 'Customer_Firstname',
        tableClient: 'Table_Client',
        clientName: 'Customner_Name',
      },
    },

    submitButton: {
      step1: 'Next step',
    },
  },

  segmentsPage: {
    table: {
      name: 'Name',
      type: 'Type',
      rights: 'Rights',
      Respondents: 'Respondents',
      avgTime: 'Average time',
      avgScore: 'Average score',
      status: 'Status',
      managers: 'Managers',
    },
  },

  navigation: {
    dropdownPanel: {
      headings: {
        analyser: 'Analyze',
        mobiliser: 'Engage',
        launchpad: 'Launchpad',
        settings: 'Settings',
      },
      columns: {
        first: {
          dashboard: 'Dashboard',
          performance: 'Performance',
        },
        second: {
          contributeurs: 'Contributors',
          certifications: 'Certifications',
          segments: 'Segments',
        },
        third: {
          projets: 'Projects',
          formulaires: 'Forms',
          workflows: 'Workflows',
          risks: 'Fraud',
        },
        fourth: {
          managers: 'Managers',
          consommation: 'Consumption',
          facturation: 'Billing',
          paramètres: 'Settings',
          logout: 'Log out',
        },
      },
      subtitles: {
        performance: 'Track the metrics',
        contributeurs: 'Manage your users',
        certifications: 'Create skill tests',
        segments: 'Create your user groups',
        projets: 'Manage your projects',
        formulaires: 'Manage your entry forms',
        risks: 'Configure your anti-fraud models',
        managers: 'Manage your managers',
        logout: 'Close your session',
      },
    },
  },
  questionPage: {
    headerTitle: 'Question %{id}',
    archiveButtonLabel: 'Archive',
    submitButtonLabel: 'Submit',
  },
  settings: {
    tabs: {
      general: 'General',
      apiKeys: 'API keys',
      profile: 'My profile',
      changePassword: 'Change password',
    },
  },
};

export default en;
export type Translations = typeof en;
